import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { Configuration, BankAccountSearchDTO, BankAccountDTO, CreateBankAccountDTO, UpdateBankAccountDTO, BankAccountsApi } from "@inosio/payments-sdk";
import { selectCurrentUser } from "../auth/authSlice";
import { 
  getFetchingBankAccountsData,
  setFetchingBankAccountsData,
  getFetchingBankAccountsDataFailed,
  getCreatingBankAccount,
  setCreatingBankAccount,
  getCreatingBankAccountFailed,
  getUpdatingBankAccount,
  setUpdatingBankAccount,
  getUpdatingBankAccountFailed,
  getDeletingBankAccount,
  setDeletingBankAccount,
  getDeletingBankAccountFailed,
} from "./bankAccountsSlice";
import {IpaUserExtended} from "../auth/authSlice";

const { REACT_APP_IPA_BASE_PATH } = process.env;
const apiConfig = new Configuration({ basePath: REACT_APP_IPA_BASE_PATH });

export function requestFetchingBankAccountsData(
  access_token: string,
  bankAccountDTO: BankAccountSearchDTO
) {
  apiConfig.accessToken = access_token;
  const ipaBankAccountsAPI = new BankAccountsApi(apiConfig);
  return ipaBankAccountsAPI.searchBankAccounts(bankAccountDTO);
}

export function requestCreatingBankAccount(
  access_token: string,
  bankAccountDTO: CreateBankAccountDTO
) {
  apiConfig.accessToken = access_token;
  const ipaBankAccountsAPI = new BankAccountsApi(apiConfig);
  return ipaBankAccountsAPI.createBankAccount(bankAccountDTO);
}

export function requestUpdatingBankAccount(
  access_token: string,
  bankAccountUUID: string,
  bankAccountDTO: UpdateBankAccountDTO
) {
  apiConfig.accessToken = access_token;
  const ipaBankAccountsAPI = new BankAccountsApi(apiConfig);
  return ipaBankAccountsAPI.updateBankAccount(bankAccountUUID, bankAccountDTO);
}

export function requestDeletingBankAccount(
  access_token: string,
  bankAccountUUID: string
) {
  apiConfig.accessToken = access_token;
  const ipaBankAccountsAPI = new BankAccountsApi(apiConfig);
  return ipaBankAccountsAPI.deleteBankAccount(bankAccountUUID);
}

export function* handleFetchingBankAccounts(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<BankAccountDTO> = yield call(
      requestFetchingBankAccountsData,
      currentUser.accessToken,
      action.payload
    );
    const { data } = response;

    yield put(setFetchingBankAccountsData(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(getFetchingBankAccountsDataFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode
      }));
    } else {
      yield put(getFetchingBankAccountsDataFailed({ ...error }));
    }
  }
}

export function* handleCreatingBankAccount(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<BankAccountDTO> = yield call(
      requestCreatingBankAccount,
      currentUser.accessToken,
      action.payload
    );
    const { data } = response;

    yield put(setCreatingBankAccount(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(getCreatingBankAccountFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode
      }));
    } else {
      yield put(getCreatingBankAccountFailed({ ...error }));
    }
  }
}

export function* handleUpdatingBankAccount(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<BankAccountDTO> = yield call(
      requestUpdatingBankAccount,
      currentUser.accessToken,
      action.payload.Uuid,
      action.payload
    );
    const { data } = response;

    yield put(setUpdatingBankAccount(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(getUpdatingBankAccountFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode
      }));
    } else {
      yield put(getUpdatingBankAccountFailed({ ...error }));
    }
  }
}

export function* handleDeletingBankAccount(action: any) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<BankAccountDTO> = yield call(
      requestDeletingBankAccount,
      currentUser.accessToken,
      action.payload.Uuid
    );

    const { data } = response;

    yield put(setDeletingBankAccount(data));
  } catch (error: any) {
    if (error?.response?.data) {
      yield put(getDeletingBankAccountFailed({
        message: error?.response?.data?.message,
        statusCode: error?.response?.data?.statusCode
      }));
    } else {
      yield put(getDeletingBankAccountFailed({ ...error }));
    }
  }
}

export function* bankAccountsSaga() {
  yield takeLatest(getFetchingBankAccountsData.type, handleFetchingBankAccounts);
  yield takeLatest(getCreatingBankAccount.type, handleCreatingBankAccount);
  yield takeLatest(getUpdatingBankAccount.type, handleUpdatingBankAccount);
  yield takeLatest(getDeletingBankAccount.type, handleDeletingBankAccount);
}
